import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetCatalogLimitQuery = (catalogUid: string, limitUid: string) => {
  return useQuery({
    queryKey: ['getCatalogLimit', limitUid, catalogUid],
    queryFn: () => Api.products.getCatalogLimit(catalogUid, limitUid),
    enabled: !!catalogUid && !!limitUid,
  });
};
